module.exports = "/images/vendor/vue-paycard/src/mastercard.png?f85b4a421707795cdfebc18116b8284f";